import http from "../../Http/Http-processcommon";
const NombreDelModulo = "Hosts";

class PreguntaFinalDataService {
    async getAll(id) {
        return await http.get(`/${NombreDelModulo}/GetPreguntas?id=${id}`);
        // return await http.get(`/${NombreDelModulo}?idFilter=${idFilter}&search=${search}&page=${page}&rows=${rows}`);
    }
    async getIdEtapa() {
        return await http.get(`/${NombreDelModulo}/GetIdEtapa`);
    }
    async getEtapa(idEtapa) {
        return await http.get(`/${NombreDelModulo}/GetEtapa?idEtapa=${idEtapa}`);
    }
    async activarEtapa(idEtapa) {
        return await http.get(`/${NombreDelModulo}/ActivarEtapa?idEtapa=${idEtapa}`);
    }
    async getAvance(idEtapa, idPregunta) {
        return await http.get(`/${NombreDelModulo}/GetAvanceEtapaPreguntaSesion?IdEtapa=${idEtapa}&IdPregunta=${idPregunta}`);
    }
    async desactivarEtapa(idEtapa) {
        return await http.get(`/${NombreDelModulo}/DesactivarEtapa?idEtapa=${idEtapa}`);
    }
    async finalizarSesion() {
        return await http.get(`/${NombreDelModulo}/FinalizarSesion`);
    }
    async patch(idEtapa, id, ban) {
        return await http.get(`/${NombreDelModulo}/patch?idEtapa=${idEtapa}&id=${id}&ban=${ban}`);
    }


    //ACTUALIZACION
    async getAllV2(id) {
        return await http.get(`/${NombreDelModulo}/GetPreguntasSesion?id=${id}`);
        // return await http.get(`/${NombreDelModulo}?idFilter=${idFilter}&search=${search}&page=${page}&rows=${rows}`);
    }

    async getAvanceV2(idEtapa, idPregunta) {
        return await http.get(`/${NombreDelModulo}/GetAvanceEtapaPreguntaSesionV2?IdEtapa=${idEtapa}&IdPregunta=${idPregunta}`);
    }

    async patchV2(idEtapa, id, ban) {
        return await http.get(`/${NombreDelModulo}/patchV2?idEtapa=${idEtapa}&id=${id}&ban=${ban}`);
    }
}

export default new PreguntaFinalDataService();
